import axios from 'axios';
import authHeader from '../services/AuthHeader';
import {ENV_URL} from './Globals';
const ALBUMS_URL = `${ENV_URL}/api/v1/albums`;

class AlbumDataService {

    //Get All Albums
    getAllAlbums() {
        return axios.get(`${ALBUMS_URL}`, {
            headers: authHeader()
        });
    };


//CREATE Album 
createAlbum(fileData) {
    return axios.post(`${ALBUMS_URL}`,fileData, {
        "Content-Type": "multipart/form-data",
        headers: authHeader()
    });
};


//Get Album by Id  
getAlbumById(albumId) {
    return axios.get(`${ALBUMS_URL}/${albumId}`, {
        headers : authHeader()
    });
};


//Get Album by Name
getAlbumByName(albumName) {
    return axios.get(`${ALBUMS_URL}/name/${albumName}`, {
        headers : authHeader()
    });
};


    //Update Album data 
    updateAlbumData(id,data) {
        return axios.put(`${ALBUMS_URL}/${id}`, data , {
            headers : authHeader
        });
    };

  //DELETE  Album 
  deleteAlbum(id) {
    return axios.delete(`${ALBUMS_URL}/${id}`, {
        headers: authHeader()
    });
};

  //get all images related to Album 
  getAllAlbumImages(id) {
    return axios.get(`${ALBUMS_URL}/${id}/images`, {
        headers: authHeader()
    });
};

//   //Remove image from Album
//   removeImageFromAlbum(albumId,imageId) {
//     return axios.delete(`${ALBUMS_URL}/${albumId}/images/remove/${imageId}`, {
//         headers: authHeader()
//   });
// };

 
};

const albumDataService = new AlbumDataService();
export default albumDataService;

